// CBOR WS protocol (mirror backend/src/types/ws.ts). cbor-x object frames.
import { Encoder } from "cbor-x";
import type { AuthorTypeWire, CommentDTO, PlaybackEndpoint, StreamStatus } from "../api/types.js";

const enc = new Encoder({ useRecords: false, tagUint8Array: false });
export const encode = (m: unknown): Uint8Array => enc.encode(m);
export const decode = (b: Uint8Array): unknown => enc.decode(b);

export interface WsLiveNode {
  id: string;
  name: string;
  region: string;
  driver: string;
}

export type ClientMsg =
  | { t: "join"; streamId: string }
  | { t: "heartbeat" }
  | { t: "chat"; body: string; nonce: string }
  | { t: "fetchComments"; limit?: number; beforeTs?: number };

export type ChatMsg = {
  t: "chat";
  id: string;
  userId: string | null;
  name: string;
  avatar: string | null;
  authorType: AuthorTypeWire;
  isStreamer: boolean;
  body: string;
  ts: number;
};

export type StatusMsg = {
  t: "status";
  state: StreamStatus;
  scheduledStartAt?: number | null;
  liveNode?: WsLiveNode | null;
  playbackEndpoints?: PlaybackEndpoint[];
  startedAt?: number | null;
};

export type ServerMsg =
  | ChatMsg
  | StatusMsg
  | { t: "viewers"; count: number }
  | { t: "comments"; comments: CommentDTO[] }
  | { t: "ack"; nonce: string }
  | { t: "sys"; level: "info" | "warn"; body: string };
